import { api } from "../base";
import type { IRiskExposureResponse } from "@pulse-ui/codegen-v2/generated_ts/risk_checks";
import type { IUpdateCustomerCreditLimitRequest } from "@pulse-ui/codegen-v2/generated_ts/venues/talos";
import type { IPulseApiResponse } from "@pulse-ui/codegen-v2/generated_ts/api";

export {
  ExposurePriceStatus,
  type IAssetExposure,
  type ICounterpartyExposure,
  type IRiskExposureResponse,
} from "@pulse-ui/codegen-v2/generated_ts/risk_checks";
export type { IUpdateCustomerCreditLimitRequest } from "@pulse-ui/codegen-v2/generated_ts/venues/talos";
export type { IPulseApiResponse } from "@pulse-ui/codegen-v2/generated_ts/api";

const riskExposureEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    getRiskExposure: build.query<IRiskExposureResponse, void>({
      query: () => ({
        url: "/api/trading-ops/v1/risk-exposure",
      }),
      providesTags: ["RiskExposure"],
    }),

    updateCustomerCreditLimit: build.mutation<
      IPulseApiResponse,
      IUpdateCustomerCreditLimitRequest
    >({
      query: (body) => ({
        url: "/api/trading-ops/v1/customer-credit-limits",
        method: "POST",
        body,
      }),
      // Talos -> risk-checks stream -> server cache propagation can outrun
      // an immediate refetch, so patch the cache for instant feedback and
      // let the 5s `getRiskExposure` poll reconcile once Talos catches up.
      async onQueryStarted({ counterparty, quantity }, { dispatch, queryFulfilled }) {
        const patch = dispatch(
          riskExposureEndpoints.util.updateQueryData(
            "getRiskExposure",
            undefined,
            (draft) => {
              const target = draft.counterparties.find(
                (cp) => cp.counterparty === counterparty,
              );
              if (target) target.exposure_limit = quantity;
            },
          ),
        );
        try {
          const { data } = await queryFulfilled;
          if (!data.success) patch.undo();
        } catch {
          patch.undo();
        }
      },
    }),
  }),
});

export const {
  useGetRiskExposureQuery,
  useUpdateCustomerCreditLimitMutation,
} = riskExposureEndpoints;
